<template>
  <div class="page-box">
    <InformList v-if="List.length > 0" :list2="List" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
    <empty class="empty-margin" v-if="List.length <= 0"></empty>
  </div>
</template>

<script>
import InformList from './InformList.vue'
import { getMessageList } from '@/api/user'
import empty from "@/components/empty/index";
export default {
  name: "LearningProgress",
  components: {
    InformList,
    empty
  },
  data() {
    return {
      List: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      }
    }
  },
  methods: {
    // 分页查询消息
    getMessageList() {
      getMessageList({
        number: this.page.number,
        limit: this.page.limit
      }).then(res => {
        this.List = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getMessageList()
    },
    currentChange(value) {
      this.page.number = value
      this.getMessageList()
    },
  },
  mounted() {
    this.getMessageList()
  }
}
</script>

<style scoped lang="less">
.page-box {
  height: 100%;
  
  .empty-margin {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/MessageCenter.vue